// extracted by mini-css-extract-plugin
export default {"DataProtection":"DataProtection_DataProtection__HrxWJ","title":"DataProtection_title__YLFC+"};